































import Vue from 'vue';
import {
  Component,
} from 'vue-property-decorator';

enum NotificationTypes {
  ERROR = 'error',
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
}

interface Notification {
  innerText: string;
  lifetime: number;
  hidden: boolean;
  dismissable: boolean;
  type: NotificationTypes;
}

@Component({
  components: {
  },
})
export default class NotificationsSnackbar extends Vue {
  notifications: Array<Notification> = [
    {
      innerText: '',
      lifetime: 0,
      hidden: true,
      dismissable: true,
      type: NotificationTypes.INFO,
    },
  ]

  NotificationTypes = NotificationTypes;

  beforeMount() {
    this.$bus.$on('notification', this.addNotification);
  }

  addNotification(text: string, type: NotificationTypes = NotificationTypes.INFO, lifetime = 10, dismissable = true) {
    const notification = {
      innerText: text,
      type,
      lifetime,
      dismissable,
      hidden: false,
    };
    this.notifications.push(notification);
    setTimeout(() => {
      notification.hidden = true;
    }, lifetime * 1000);
  }

  dismiss(notification: Notification) {
    notification.hidden = true;
  }
}
